"use client";

import { useFetchRunningJobs } from "@/app/hooks/fetchs/user/useFetchRunningJobs";
import { useInvalidateOnJobCompletion } from "@/app/hooks/useInvalidateOnJobCompletion";
import { useNotifyFailedJobs } from "@/app/hooks/useNotifyFailedJobs";
import { PageParams } from "@/app/types/common/DefaultProps";

export type JobWatcherProps = {
  params: PageParams;
};

export default function JobWatcher(props: JobWatcherProps) {
  const { params } = props;

  const { data: runningJobs } = useFetchRunningJobs();
  useInvalidateOnJobCompletion(runningJobs);
  useNotifyFailedJobs(params);

  return null;
}
